/**
 * Copyright 2025 Beijing Volcano Engine Technology Co., Ltd. All Rights Reserved.
 * SPDX-license-identifier: BSD-3-Clause
 */

import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useDeviceState, useLeave, useScene } from '@/lib/useCommon';
import { isMobile } from '@/utils/utils';
import { RootState } from '@/store';
import { updateShowSubtitle } from '@/store/slices/room';
import CallControls from './CallControls';

function ToolBar(props: React.HTMLAttributes<HTMLDivElement>) {
  const { className, ...rest } = props;
  const dispatch = useDispatch();
  const room = useSelector((state: RootState) => state.room);
  const isShowSubtitle = room.isShowSubtitle;
  const { isScreenMode } = useScene();
  const leaveRoom = useLeave();
  const {
    isAudioPublished,
    isVideoPublished,
    isScreenPublished,
    switchMic,
    switchCamera,
    switchScreenCapture,
  } = useDeviceState();

  return (
    <CallControls
      {...rest}
      className={className}
      audioOn={Boolean(isAudioPublished)}
      videoOn={Boolean(isVideoPublished)}
      screenOn={Boolean(isScreenPublished)}
      subtitlesOn={isShowSubtitle}
      screenMode={isScreenMode}
      mobile={isMobile()}
      onMic={() => switchMic(true)}
      onCamera={() => switchCamera(true)}
      onScreen={() => switchScreenCapture(true)}
      onSubtitles={() => dispatch(updateShowSubtitle({ isShowSubtitle: !isShowSubtitle }))}
      onLeave={leaveRoom}
    />
  );
}
export default memo(ToolBar);
